"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerksDescription = void 0;
const react_bootstrap_1 = require("react-bootstrap");
const styled_components_1 = __importDefault(require("styled-components"));
exports.PerksDescription = styled_components_1.default(react_bootstrap_1.Container).withConfig({ displayName: "PerksDescription", componentId: "sc-8n6ovv-0" })(["margin-bottom:25px;max-width:640px;"]);
